export default __webpack_public_path__ + "static/media/soluciones__3.54f3fde8.png";